module.exports = __webpack_public_path__ + "static/media/active_video_thumb3.f267eaac.svg";